/**
 * Created by yihong on 1/15/18.
 */
export const ACTION_GET_USER_INFO = 'ACTION_GET_USER_INFO'; // 获取ticket后发出信息，用于调用接口获取用户信息

export const PAGE_CREATE = 'PAGE_CREATE'; // HOMEPAGE CREATED时发出　用来调用接口，不要用于dom操作

export const ACTION_GET_ACT_INFO = 'ACTION_GET_ACT_INFO'; // 获取用活动信息

export const USRE_INFO_LOAD = 'USRE_INFO_LOAD'; // 用户信息加载完成

export const SHARE_SUCCESS = 'SHARE_SUCCESS'; // 分享成功

export const HIDE_COMP = 'HIDE_COMP' //隐藏模块

export const GET_GIFT = 'GET_GIFT' //领取礼物


